import FloatingSupportButton from "../../../components/FloatingSupportButton";
import NetworkShell from "../Shell/NetworkShell";

export default function AgentNetwork() {
	return <NetworkShell footerSlot={<FloatingSupportButton />} />;
}
